import { isTruthyAndNotEmpty } from '@stimcar/libs-kernel';

export type WelcomeTitleKind = 'improve' | 'hello' | 'embellish' | 'idea' | 'attack';

export const WELCOME_TITLE_KINDS: readonly WelcomeTitleKind[] = [
  'improve',
  'hello',
  'embellish',
  'idea',
  'attack',
];

export const WELCOME_TITLE_ROTATE_MS = 7_000;

export function capitalizeNameToken(token: string): string {
  const trimmed = token.trim();
  if (!isTruthyAndNotEmpty(trimmed)) {
    return '';
  }
  return trimmed
    .split('-')
    .filter((part) => isTruthyAndNotEmpty(part))
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join('-');
}

/**
 * Best-effort first name for greetings: Keycloak given_name when present,
 * otherwise the first token of the email local-part.
 */
export function resolveWelcomeFirstName(input: {
  readonly email: string;
  readonly givenName?: string;
}): string {
  const fromGiven = input.givenName?.trim();
  if (isTruthyAndNotEmpty(fromGiven)) {
    const token = fromGiven.split(/\s+/)[0] ?? fromGiven;
    return capitalizeNameToken(token);
  }
  return firstNameFromEmail(input.email);
}

export function firstNameFromEmail(email: string): string {
  const local = email.trim().split('@')[0] ?? '';
  const token = local.split(/[._+]/)[0] ?? local;
  return capitalizeNameToken(token);
}

export function nextWelcomeTitleIndex(current: number, count: number): number {
  if (count <= 0) {
    return 0;
  }
  return (current + 1) % count;
}

export function initialWelcomeTitleIndex(seed: number, count: number): number {
  if (count <= 0) {
    return 0;
  }
  const normalized = Math.abs(Math.trunc(seed));
  return normalized % count;
}
